/** Отметки «Первых шагов» и подсказок MrDrive в localStorage. Ошибки хранилища молча игнорируются. */
export type FlagKey = "events_open" | "market_open" | "event_share" | "circle_share";

const key = (uid: string | undefined, k: FlagKey) => `td_first_step_${k}_${uid ?? "anon"}`;

export function getFlag(uid: string | undefined, k: FlagKey): boolean {
  try {
    return localStorage.getItem(key(uid, k)) === "1";
  } catch {
    return false;
  }
}

export function setFlag(uid: string | undefined, k: FlagKey): void {
  try {
    localStorage.setItem(key(uid, k), "1");
    window.dispatchEvent(new Event("td-first-steps"));
  } catch {
    /* ignore */
  }
}

const hintKey = (k: string) => `td_section_hint_${k}`;

export function hintDismissed(k: string): boolean {
  try {
    return localStorage.getItem(hintKey(k)) === "1";
  } catch {
    return false;
  }
}

export function dismissHint(k: string): void {
  try {
    localStorage.setItem(hintKey(k), "1");
  } catch {
    /* ignore */
  }
}
